import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable, { MTableAction } from "material-table";
import {IconButton, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Button} from '@material-ui/core';
import AddButton from './AddButton';


const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export  function BankAPI_kgs(props) {

    const classes = useStyles();

    const { show, data } = props;

    const tableRef = React.createRef();
    const addActionRef = React.useRef();

    const columns = [
        {title:"id", field:"kg_id"},
        {title:"Номер", field:"number"}, 
        {title:"Назва", field:"name"},
        {title:"ЄДРПОУ", field: "edrpou"},
        {title:"Район", field:"district"},
/*        {
          title: "Додати нового користувача",
          field: "add_action",
          editable: false,
          render: (rowData) =>
            rowData && (
              <IconButton
                color="secondary"
                onClick={() => addActionRef.current.click()}
              >
                <AddIcon />
              </IconButton>
            )
        }
*/
    ];

    const [template_data, setTableData] = useState(data.data);
    
    const [initDataState, setInitDataState] = useState(false);

    const [listKgs, setListKgs] = useState([]);
    
    const [display, setShow] = useState(false);


    const getListOfKg = async ()=> {

      const url = 'https://osa.kyivcity.gov.ua/bank_api/kg_list';

      const result = await fetch(url);

      if(!result.ok) {
        console.log("error by fetch", url);
        alert("Error by sending req");
        return;
      }
  
      const info = await result.json();

      const d_ = info && info.data && info.data.map(kg=>({kg_id: kg.kg_id, number: kg.number, name: kg.name, edrpou: kg.edrpou, district: kg.contacts.address.district }));

      
      setListKgs(d_);

    }


    useEffect(()=>{

      getListOfKg();

    }, []);




    const addNewUser = ()=>{
      props.addUser(true);
    }

    if(!show) return null;

    return (
      <div style={{ maxWidth: "100%" }}>
        <MaterialTable
          tableRef={tableRef}
          columns={columns}
          data={listKgs}
          title="АПІ для банків. Перелік закладів освіти"
          components={{
            Action: props=><AddButton {...props} />
          }}

          icons={
            { Add: ()=> <IconButton onClick={()=>{}} />}
          }

          actions={[
          ]}
          editable={{
            onRowAdd: (newData) =>
              Promise.resolve(setTableData([...template_data, newData]))
          }}
          options={{
            filtering: true,
            pageSize: 10,
            pageSizeOptions: [10,20,50]
          }}
        />
      </div>
    );

}